import Page from 'pages/Page';
import SliderInterface from 'components/Slider/interfaces/SliderInterface';
import NewsletterChunk from '../../modules/InitChunks/NewsletterChunk/NewsletterChunk';
import MediaQueries from '../../shared/helpers/MediaQueries';

export default class HomePages extends Page {
  constructor() {
    super();

    /*
     * Secondary script
     * */
    if (MediaQueries.mobileMedia.matches) {
      // Load files for Mobile
      document.addEventListener(
        'touchstart',
        () => {
          // Load files for other
          HomePages.importsChunks();
        },
        {
          once: true,
          passive: true,
        }
      );
    } else {
      // Load files for other
      HomePages.importsChunks();
    }
  }

  /*
   * Slider Trustpilot
   * */
  private static importSliderTrustpilotChunks(): void {
    import(
      /* webpackPrefetch: true */ /* webpackChunkName: 'prefetch-SliderTrustpilot' */ '../../components/Slider/SliderTrustpilot/SliderTrustpilot'
    ).then(({ default: SliderTrustpilot }) => {
      const sliderTrustpilot: SliderInterface = {};

      new SliderTrustpilot(sliderTrustpilot);
    });
  }

  private static importsChunks(): void {
    // Add Newsletter in page
    new NewsletterChunk();

    HomePages.importSliderTrustpilotChunks();
  }
}
